// extracted by mini-css-extract-plugin
export var createdDate = "_jp-1";
export var divider = "_jp-2";
export var headerDivider = "_jp-3";
export var messagesCard = "_jp-0";
export var messagesContainer = "_jp-6";
export var messagesContainerWrapper = "_jp-4";
export var showLeftPanelButton = "_jp-8";
export var topButtons = "_jp-7";
export var withPadding = "_jp-5";